export default __webpack_public_path__ + "static/media/05_DAIF_UseCase_04_04_Loop.d12eabbe.mp4";